// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"0efd41d2","287":"5c0b9247","297":"ddb8138d","394":"9def1a50","428":"5255a6e6","453":"e7e434ef","710":"7a965812","781":"b3f4f7b4","838":"1015b3e4","946":"17b2854e","952":"a77daa69"}[chunkId] + ".chunk.js";
};